import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import en from "vuetify/lib/locale/en";
// import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#005ca2", // Sunshine Orange
        secondary: "#0086ed", // Sunshine Orange
        accent: "#E91E63", // Magenta
        error: "#C62828", // Brick Red
        success: "#8BC34A", // Lime Green
        warning: "#FFC107", // Amber
        info: "#29B6F6", // Light Blue
      },
      dark: {
        primary: "#005ca2", // Sky Blue
        secondary: "#FFB74D", // Sunshine Orange
        accent: "#E91E63", // Magenta
        error: "#C62828", // Brick Red
        success: "#8BC34A", // Lime Green
        warning: "#FFC107", // Amber
        info: "#29B6F6", // Light Blue
      },
    },
  },
  icons: {
    iconfont: "mdiSvg", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  },
  lang: {
    locales: { en },
    current: "en",
  },
});
